import Loading from '@Components/Loading/Loading'
import ColumnData from '@Components/table/BaseTable/ColumnData'
import { IMetaData, ITableHeaders } from '@Models/common.model'
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material'
import clsx from 'clsx'
import { Fragment, useEffect, useState } from 'react'
import './BaseTable.scss'

interface IBaseTable {
    data: any[] | undefined
    metadata?: IMetaData | undefined
    headers: ITableHeaders[]
    isLoading?: boolean
    noBorder?: boolean
    noHeader?: boolean
    noStriped?: boolean
    rowClickedAction?: ({ event, data, rowIndex }: any) => void
    className?: string
}

const BaseTable = (props: IBaseTable) => {
    const {
        headers,
        data,
        noStriped,
        noHeader,
        noBorder,
        isLoading,
        metadata,
        className,
        rowClickedAction,
    } = props

    // functions section
    const handleRowClicked = (
        event: any,
        columnData: any,
        rowIndex: number
    ) => {
        const payload = { event, data: columnData, rowIndex }
        if (rowClickedAction) rowClickedAction(payload)
    }

    // generate headerDisplay
    const tableHead = headers.map((header: ITableHeaders, index: number) => {
        return (
            <TableCell
                align={header?.align}
                key={`${+index}_header`}
                className={header?.className}
                style={header?.style}
            >
                {header?.name}
            </TableCell>
        )
    })

    // generate table content
    const tableContent = data?.map((column: any, rowIndex: number) => {
        return (
            <Fragment key={`${+rowIndex}_row`}>
                <TableRow
                    onClick={(e: any) => handleRowClicked(e, column, rowIndex)}
                    className={clsx(
                        rowClickedAction && 'cursor-pointer table-row-clickable'
                    )}
                >
                    {headers?.map(
                        (header: ITableHeaders, cellIndex: number) => {
                            return (
                                <TableCell
                                    align={header?.align}
                                    key={`${+cellIndex} _cell`}
                                    className={header?.className}
                                >
                                    <ColumnData
                                        header={header}
                                        data={column}
                                        rowIndex={rowIndex}
                                        metadata={metadata}
                                    />
                                </TableCell>
                            )
                        }
                    )}
                </TableRow>
            </Fragment>
        )
    })

    return (
        <TableContainer
            className={clsx(
                'base-table tb-min-height position-relative',
                noStriped ? 'table-no-striped' : 'table-striped',
                noBorder && 'no-border',
                className
            )}
        >
            <Table aria-label="table">
                {!noHeader && (
                    <TableHead>
                        <TableRow>{tableHead}</TableRow>
                    </TableHead>
                )}
                <TableBody>
                    {tableContent}
                    {!data?.length && (
                        <TableRow>
                            <TableCell
                                className="text-center"
                                colSpan={+headers?.length}
                            >
                                No data
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
            {isLoading && (
                // <TableRow>
                //     <TableCell colSpan={+headers?.length}>
                <Loading isLoading className="tb-loading" />
                //     </TableCell>
                // </TableRow>
            )}
        </TableContainer>
    )
}

export default BaseTable
